import React from 'react';
import './DABenefits.css';

const benefits = [
  { icon: '/build.webp', title: 'IMPROVED EFFICIENCY' },
  { icon: '/icons/benefit2.webp', title: 'ENHANCED CUSTOMER EXPERIENCE' },
  { icon: '/edge.webp', title: 'INCREASED AGILITY AND INNOVATION' },
  { icon: '/decision.webp', title: 'DATA-DRIVEN DECISION-MAKING' },
  { icon: '/icons/e-commerce.png', title: 'EXPANDED MARKET REACH' },
];

const DABenefits = () => {
  return (
    <section className="da-benefits-section" id="benefits">
      <div className="container">
      <div className="da-benefits-heading">
        <h2>
          <span className="text-black">WHAT </span>
          <span className="text-blue">YOU'LL GET</span>
        </h2>
      </div>

      <div className="da-benefits-row top-row">
        {benefits.slice(0, 3).map((benefit, index) => (
          <div className="da-benefit-card" key={index}>
            <img src={benefit.icon} alt={benefit.title} className="da-benefit-icon" />
            <p className="da-benefit-title">{benefit.title}</p>
          </div>
        ))}
      </div>

      <div className="da-benefits-row bottom-row">
        {benefits.slice(3).map((benefit, index) => (
          <div className="da-benefit-card" key={index + 3}>
            <img src={benefit.icon} alt={benefit.title} className="da-benefit-icon" />
            <p className="da-benefit-title">{benefit.title}</p>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
};

export default DABenefits;
